<template>
  <Layout>
    <template #header>
      <Heading>{{ $t('global_success') }}</Heading>
      <CloseButton @click="$emit('close')" />
    </template>

    <template #default>
      <div class="ss-main">
        <div class="ss-main-img">
          <img class="ss-img" :src="mainImg" alt="" />
        </div>
        <div class="ss-main-copy">
          <!-- eslint-disable vue/no-v-html -->
          <Subheading
            class="ss-text"
            v-html="
              $t('ppm_modal__success_subheading', {
                accountType: getAccountType(paymentAccount),
                msg: getCardSuccessMessage(paymentAccount),
              })
            "
          />
          <!-- eslint-enable vue/no-v-html -->
        </div>
      </div>
    </template>

    <template #footer>
      <HotPinkButton @click="$emit('go-to-financials')">
        {{ $t('ppm_modal__financials_redirect_text2') }}
      </HotPinkButton>
    </template>
  </Layout>
</template>

<script>
import CardMixin from '../mixins/CardMixin'
import Layout from '../layouts/Layout.vue'
import Heading from '../typography/Heading.vue'
import Subheading from '../typography/Subheading.vue'
import HotPinkButton from '../buttons/HotPinkButton.vue'
import CloseButton from '@/components/shared/Dialogs/CloseButton.vue'

export default {
  components: {
    Layout,
    Heading,
    Subheading,
    HotPinkButton,
    CloseButton,
  },
  mixins: [CardMixin],
  props: {
    paymentAccount: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mainImg: require('../assets/success.png'),
    }
  },
}
</script>

<style lang="postcss" scoped>
.ss-main {
  /* Base */
  @apply tw-flex tw-flex-col tw-items-center tw-mt-6 tw-gap-5;

  /* Desktop */
  @apply lg:tw-gap-3;
}

.ss-img {
  /* Base */
  @apply tw-w-[258px] tw-h-[176px] tw-object-contain;

  /* Desktop */
  @apply lg:tw-w-[360px] lg:tw-h-[260px];
}

.ss-main-copy {
  /* Base */
  @apply tw-max-w-[316px];

  /* Desktop */
  @apply lg:tw-max-w-[620px];
}

.ss-text {
  /* Base */
  @apply tw-mb-0;
}
</style>
